import React, { useEffect, useState } from "react";
import axios from "../api/axios";
import SearchBar from "../components/SearchBar";
import FeaturedProducts from "../components/FeaturedProducts";
import CategoryList from "../components/CategoryList";
import ProductList from "../components/ProductList";
import Brands from "../components/BrandList";
const Home = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get("/products");
        setProducts(data);
      } catch (error) {
        console.error("❌ Error cargando productos:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  return (
    // Fondo azul ocupando toda la pantalla
    <div className="bg-blue-50 min-h-screen pt-10">
      {/* Contenedor centrado con padding lateral */}
      <div className="container mx-auto px-4">
        <h2 className="text-2xl font-bold text-center my-6">¡La mejor calidad para tu mascota!</h2>
        <SearchBar />
        <FeaturedProducts />
        <CategoryList />
        <Brands />
        <h2 id="all-products-section" className="text-2xl font-bold text-center my-6">Todos los Productos</h2>
        {loading ? (
          <p className="text-center text-gray-500">⏳ Cargando productos...</p>
        ) : (
          <ProductList products={products} />
        )}
      </div>
    </div>
  );
};

export default Home;
